export namespace StorageKey {
    export const SK_BEAR_TOKEN: string = "bear-token";
}
